import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveFund,
  setShowGimlaiMobile,
} from "../../state/actions/DashboardActions";
import { useTranslation } from "react-i18next";
import arrowLeftIcon from "../../assets/images/arrow-left.png";
import blackWallet from "../../assets/images/black-wallet.png";
import { dateDotFormat } from "../../utils/helpers/dateFormatter";
import "./GimlaiCarouselItem.scss";
import GimlaiCarouselItemProps from "./GimlaiCarouselItemProps";
import { numberWithCommas } from "../../utils/helpers/numberConverter";

const GimlaiCarouselItem = (props: GimlaiCarouselItemProps) => {
  const { userId, userFunds, isAmit, isPensioner,pensionTypeDesc } = useSelector(
    (state: any) => state.UserReducer
  );
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setActiveFund(props.fund));
    dispatch(setShowGimlaiMobile(true));
  };

  // dont delete it will be use in the future 
  const getPensionTypeDesc = (pensionTypeDesc: string) => {   
    switch (pensionTypeDesc) {
      case "קרן פנסיה":
        return t("Dashboard.pensionFund");
        case "קצבת זקנה":
        return t("Dashboard.oldAgePension");
      case "קצבת נכות":
        return t("Dashboard.disabilityPension");
      case "שארי מבוטח":
        return t("Dashboard.shariInsured");
      case "שארי פנסיונר":
        return t("Dashboard.shariInsured");
      default:
        return "";
    }
  };
 
  return (
    <>
      <div className="carousel-item-text-wrapper">
        <div className="d-flex align-items-center justify-content-space-between">
          <span className="carousel-item-fund-name">
          {localStorage.getItem("lang") === "ar"
                    ? props?.fund?.fundNameArab
                    : props?.fund?.fundLabel}
          </span>
          <div className="carousel-item-badge-wrapper">
            <img
              className="carousel-item-fund-icon"
              src={blackWallet}
              alt="black-wallet" 
              role="presentation"
              aria-hidden="true"              
            />
            <span className="carousel-item-icon-text">
              {t("general.kitzva")}
            </span>
          </div>
        </div>
        <span className="carousel-item-fund-desc">
          {props.pensionDesc && props.pensionDesc[props.fund.fundCode] ? props.pensionDesc[props.fund.fundCode] : null }
        </span>
      </div>
      <div className="carousel-item-middle-wrapper">
        <span className="carousel-item-middle-title">
        
        </span>
        <div style={{ marginTop: -10 }}>
          <span className="carousel-item-shekel">₪</span>
          <span className="carousel-item-middle-value">
            {numberWithCommas(Math.floor(props?.lastSalaryData?.salaryNeto)) || 0 }
          </span>
        </div>
      </div>
      {props?.lastSalaryData?.salaryDate?.length ? (
        <div className="carousel-item-bottom-wrapper">
          <span>{`${t("Dashboard.lastDeposit")}: ${dateDotFormat(
            props.lastSalaryData.salaryDate
          )}`}</span>

          <button className="carousel-item-button" onClick={handleClick}>
            <span>{t("general.moreDetails")}</span>
            <img src={arrowLeftIcon} alt="" />
          </button>
        </div>
      ) : (
        <div
          className="carousel-item-bottom-wrapper"
          style={{ justifyContent: "end" }}
        >
          <button className="carousel-item-button" onClick={handleClick}>
            <span>{t("general.moreDetails")}</span>
            <img src={arrowLeftIcon} alt="" />
          </button>
        </div>
      )}

      {/* <div className="carousel-item-bottom-wrapper">
        <span>{`${t("Dashboard.lastDeposit")}: ${
          props?.lastSalaryData?.salaryDate &&
          dateDotFormat(props?.lastSalaryData?.salaryDate)
        }`}</span>
        <button className="carousel-item-button" onClick={handleClick}>
          <span>{t("general.moreDetails")}</span>
          <img src={arrowLeftIcon} alt="" />
        </button>
      </div> */}
    </>
  );
};

export default GimlaiCarouselItem;
